<template>
  <figure>
    <h3 class="subtitle is-5">What Occurred</h3>
    <ul>
      <li v-for="a in agg" :key="a.key">
        <b-checkbox v-model="selected" :native-value="a.key">
          {{ message(a.key) }}: {{ a.count.toLocaleString() }}
        </b-checkbox>
      </li>
    </ul>
    <div v-if="selected.length > 0" class="buttons mt-4 is-centered">
      <b-button type="is-primary" @click="filter">
        Filter by {{ selected.length.toLocaleString() }}
        event{{ selected.length === 1 ? '' : 's' }}
      </b-button>
    </div>
  </figure>
</template>

<script>
import { mobileMessages } from "@/services/consts";
import { pascalToHuman } from "@/services/text/humanify";

export default {
  emits: ['filter'],
  props: {
    agg: Array
  },
  data () {
    return {
      selected: []
    }
  },
  methods: {
    message(i) {
      if (mobileMessages.includes(i)) return "Mobile Events";
      return pascalToHuman(i);
    },
    filter () {
      // set device type
      let deviceType = 'desktop'
      if (this.selected.length === 1 && mobileMessages.includes(this.selected[0])) {
        deviceType = 'mobile'
      }
      this.$store.commit('filters/setDeviceType', deviceType)
      // set messages
      this.$store.commit('filters/setMessages', this.selected)
      this.$emit('filter')
    }
  }
}
</script>